export default "__VITE_ASSET__Byykgrpu__"